import { create } from 'zustand';

interface StoryState {
  isVisible: boolean;
  openStory: () => void;
  closeStory: () => void;
}

export const useStoryStore = create<StoryState>((set) => ({
  isVisible: false,
  
  openStory: () => {
    set({ isVisible: true });
  },
  
  closeStory: () => {
    set({ isVisible: false });
  },
}));